/* @flow weak */
import BankAccountSelector from './BankAccountSelector.jsx';
import BoxBody from 'components/BoxBody.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import Button from 'components/Button.jsx';
import cx from 'classnames';
import DepositButton from './DepositButton.jsx';
import Money from './Money.jsx';
import Activity from 'entities/Activity';
import React from 'react';
import Receipt from './Receipt.jsx';
import ReceiptBody from './ReceiptBody.jsx';
import ReceiptRow from './ReceiptRow.jsx';
import Text from 'components/Text.jsx';

import './styles/DepositModalDepositView.scss';

const DepositModalDepositView = React.createClass({
  propTypes: {
    activity: React.PropTypes.instanceOf(Activity).isRequired,
    onDeposited: React.PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      externalAccountResource: null,
    };
  },

  onBankAccountSelected(externalAccountResource) {
    this.setState({ externalAccountResource });
  },

  render() {
    const balance = this.props.activity.getCurrentBalance();
    const bankAccount = this.state.externalAccountResource && this.state.externalAccountResource.getBankAccount();

    return (
      <div className={cx('DepositModalDepositView', this.props.className)}>
        <BoxHeader title="Review and deposit your funds" />
        <BoxBody>
          <BankAccountSelector onSelect={this.onBankAccountSelected} />
          <Receipt className="DepositModalDepositView-table">
            <ReceiptBody>
              <ReceiptRow>
                <span>Account name</span>
                <Text truncate>
                  {
                    bankAccount &&
                    this.state.externalAccountResource.getName()
                  }
                </Text>
              </ReceiptRow>
              <ReceiptRow>
                <span>Rounting number</span>
                <span>
                  {
                    bankAccount &&
                    bankAccount.getRoutingNumber()
                  }
                </span>
              </ReceiptRow>
              <ReceiptRow>
                <span>Account number (last 4 digits)</span>
                <span>
                  {
                    bankAccount &&
                    bankAccount.getAccountNumberLastFourDigits()
                  }
                </span>
              </ReceiptRow>
            </ReceiptBody>
          </Receipt>
          {!bankAccount ?
            <Button
              className="DepositModalDepositView-submit"
              disabled
              eventElementName="DepositModalDepositView-submit">
              Deposit <Money cents={balance} />
            </Button> :
            <DepositButton
              className="DepositModalDepositView-submit"
              disabled={!bankAccount}
              activity={this.props.activity}
              amount={balance}
              account={bankAccount}
              onSuccess={this.props.onDeposited}
            />
          }
        </BoxBody>
      </div>
    );
  },
});

export default DepositModalDepositView;



// WEBPACK FOOTER //
// ./src/payments/components/DepositModalDepositView.jsx